import { provider } from '@/provider.js'
import { logFeature } from '@/helpers/featureActivity'

export default {
  async createScreenLayoutItem({ commit }, newScreenLayoutData) {
    const layout = await provider.createScreenLayoutItem(newScreenLayoutData)
    if (!layout.error) {
      commit("screenLayoutItemAdded", layout)
      commit("displayFlashMessage", { message: layout.message, severity: "success" })
    } else {
      commit("displayFlashMessage", { message: layout.message, severity: "error" })
    }
  },
  async updateScreenLayoutItem({ commit }, updatedLayoutData) {
    const result = await provider.updateScreenLayoutItem(updatedLayoutData)
    if (result.error) {
      commit("displayFlashMessage", { message: result.message, severity: "error" })
    }
  },
  async deleteScreenLayoutItem({ commit }, data) {
    const result = await provider.deleteScreenLayoutItem(data)
    if (!result.error) {
      commit("screenLayoutItemRemoved", data.id)
      commit("displayFlashMessage", { message: result.message, severity: "success" })
    } else {
      commit("displayFlashMessage", { message: result.message, severity: "error" })
    }
  },
  async getJobsPage({ commit }, data) {
    const result = await provider.getJobsPage(data)
    if (!result.error) {
      if (data.myJobsOnly) {
        commit("setMyJobs", result)
        commit("setTotalPages", result)
      } else {
        commit("setAllJobs", result)
      }
      commit("setTotalPages", result)
    }
  },
  // Updates account.lifeCycleCallbacks (JSON string from Features / Runtime UI, or object).
  // Optional llmApiKey is stored in Vault (never in attrs), same pattern as email passwords.
  async setScriptEngineAttrs({ commit }, data) {
    let attrs = data
    let llmApiKey
    if (data && typeof data === "object" && !Array.isArray(data) && (data.attrs !== undefined || data.llmApiKey !== undefined)) {
      attrs = data.attrs
      llmApiKey = data.llmApiKey
    }
    if (typeof attrs === "string") {
      try {
        attrs = attrs.trim() ? JSON.parse(attrs) : {}
      } catch (e) {
        commit("displayFlashMessage", { message: "Invalid lifecycle / runtime JSON", severity: "error" })
        return
      }
    }
    if (attrs && typeof attrs === "object" && attrs.params && typeof attrs.params === "object") {
      delete attrs.params.llm_api_key
      delete attrs.params.llmApiKey
      delete attrs.params.openai_api_key
    }
    logFeature("runtime-vault", "persist", "Persisting account runtime settings", {
      hasKeyUpdate: !!(llmApiKey && String(llmApiKey).trim()),
    })
    const response = await provider.setScriptEngineAttrs(attrs, llmApiKey)
    if (response.error) {
      commit("displayFlashMessage", { message: response.message, severity: "error" })
    } else {
      if (response.account) {
        commit("setAccountDetails", response.account)
      }
      commit("displayFlashMessage", { message: response.message, severity: "success" })
    }
  },
  clearJobLog({ commit }) {
    commit("clearJobLog")
  },
  async getJobLog({ commit }, { jobId, page, pageSize, sortBy, descending }) {
    const { job } = await provider.getJobLogs(parseInt(jobId, 10), page, pageSize, sortBy, descending)
    commit("getJobLog", job.logs)
    return job.logs
  },
  async setAccountFeatures({ commit, rootState }, entries) {
    const list = entries || []
    for (let i = 0; i < list.length; i++) {
      const response = await provider.setAccountFeature(list[i])
      if (!response || response.error) {
        const message = response && response.message ? response.message : "Unable to update account feature."
        commit("displayFlashMessage", { message, severity: "error" })
        return
      }
    }
    if (list.length) {
      commit("displayFlashMessage", { message: "Account features updated.", severity: "success" })
    }
    const audit = list.find((entry) => entry.code === "audit")
    if (audit) {
      commit("setAuditEnabled", !!audit.enabled)
      const caseTypes = rootState.caseTypes && rootState.caseTypes.all
      commit("reloadConfigMenu", caseTypes || [])
    }
  },
  async performReindex({ commit }, options = {}) {
    const response = await provider.performReindex(options)
    if (response && !response.error) {
      commit("displayFlashMessage", { message: response.message, severity: "success" })
    } else {
      commit("displayFlashMessage", { message: response.message, severity: "error" })
    }
  }
}
